
// ** Dropdowns Imports
import { memo } from "react"
import { Menu, Moon, Sun } from "react-feather"
import { NavItem, NavLink } from "reactstrap"
const NavbarUser = ({ skin, setSkin, setMenuVisibility, cfilters }) => {

	return (
		<div className="bookmark-wrapper d-flex align-items-center">
			<ul className="navbar-nav d-xl-none" style={{ margin: "2rem 0 0 2rem" }}>
				<NavItem className="mobile-menu me-auto">
					<NavLink
						className="nav-menu-main menu-toggle hidden-xs is-active"
						onClick={() => setMenuVisibility(true)}
					>
						<Menu className="ficon" />
					</NavLink>
				</NavItem>
			</ul>
		</div>
	)
}
export default memo(NavbarUser)
